"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pietrasanta": {
    "2f32013c": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "baccatoio": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "1d1c0fb5": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "62052c06": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "citta-giardino": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "9d613df2": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "crociale": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "35ba6157": [{
      "hkey": "d4f7b8db",
      "slug": "focette",
      "name": "Focette",
      "primary": true,
      "skipSearch": false
    }],
    "focette": [{
      "hkey": "d4f7b8db",
      "slug": "focette",
      "name": "Focette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "marina-di-pietrasanta"
    }],
    "e2b425e2": [{
      "hkey": "38a64b2b",
      "slug": "pietrasanta",
      "name": "Pietrasanta",
      "primary": true,
      "skipSearch": false
    }],
    "macelli": [{
      "hkey": "38a64b2b",
      "slug": "pietrasanta",
      "name": "Pietrasanta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0dbdf817": [{
      "hkey": "6c3eb6fd",
      "slug": "strettoia",
      "name": "Strettoia",
      "primary": true,
      "skipSearch": false
    }],
    "montiscendi": [{
      "hkey": "6c3eb6fd",
      "slug": "strettoia",
      "name": "Strettoia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "f0db78d6": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ponterosso": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "1746527b": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pontestrada": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "a26fffaa": [{
      "hkey": "ed2e2f82",
      "slug": "valdicastello",
      "name": "Valdicastello",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "876e0a03",
      "slug": "vallecchia",
      "name": "Vallecchia",
      "primary": true,
      "skipSearch": false
    }],
    "prima-collina-pedecollinare": [{
      "hkey": "876e0a03",
      "slug": "vallecchia",
      "name": "Vallecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "edcf6a9a": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "traversagna": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "590f5dd3": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "vaiana": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }],
    "1a4d307f": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "vecchiuccio": [{
      "hkey": "4b4ae772",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrasanta"
    }]
  }
};
exports["default"] = _default;